import {
  GET_INVOICES,
  GET_INVOICES_SUCCESS,
  GET_INVOICES_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  invoices: [],
  error: null,
  loading: false,
}
const Invoices = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_INVOICES:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case GET_INVOICES_SUCCESS:
      return {
        ...state,
        error: null,
        invoices: action.payload,
        loading: false,
      }

    case GET_INVOICES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    default:
      return state
  }
}

export default Invoices
